import React, { useEffect, useState } from 'react';
import axios from 'axios';

import issueImg from 'img/icon/issue.svg';

import Intro from 'components/Intro';
import Item from 'components/SocialSurvey/Issue/Item';

import { API_URL } from 'utils/config';

const API_ENDPOINT = `${API_URL}/researches-issue/`;

const Content = () => {
  const [issueList, setIssueList] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const pageData = {
    title: '聚焦主題',
    page: 'issue',
    icon: issueImg,
  };

  useEffect(() => {
    const fetchIssueList = async () => {
      try {
        const response = await axios.get(API_ENDPOINT);
        setIssueList(response.data.records);
      } catch (err) {
        console.error('取得聚焦主題資料失敗：', err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchIssueList();
  }, []);

  if (loading) return <p>載入中...</p>;
  if (error) return <p>載入失敗，請聯繫網站管理員協助處理</p>;

  return (
    <>
      <article className="l-issue">
        <section className="l-issue__title u-section">
          <Intro data={pageData} />
        </section>
        <section className="l-issue__data">
          <div className="row g-4">
            {issueList.map((v) => {
              const { id } = v;
              return <Item key={id} data={v} />;
            })}
          </div>
        </section>
      </article>
    </>
  );
};

export default Content;
